import groupBy from 'lodash/groupBy';

export function brandingState(
  state = {
    brandingsById: {},
  },
  action
) {
  switch (action.type) {
    case 'RECEIVED_BRANDINGS': {
      const { brandings } = action.value;
      const brandingsById = groupBy(brandings, 'id');
      return { ...state, brandings, brandingsById };
    }
    default: {
      return state;
    }
  }
}
